module.exports = __webpack_public_path__ + "static/media/delete_outline-24px (1).df793215.svg";